export default "__VITE_ASSET__BnxpwbxN__"